import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/img/defaultprofile.jpg'


const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "boxTitle" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "form-group w-50" }
const _hoisted_5 = { class: "midTitle" }
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = {
  key: 0,
  class: "fs-14"
}
const _hoisted_9 = { class: "text-center w-50" }
const _hoisted_10 = { ref: "qrcanvas" }
const _hoisted_11 = { class: "wrapContainer" }
const _hoisted_12 = { class: "referralBox" }
const _hoisted_13 = { class: "referralBoxNumber" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "referralBoxItem"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "boxTitle"
}
const _hoisted_18 = { class: "scrollListContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_caricamento_contratto = _resolveComponent("caricamento-contratto")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "Aiuta i tuoi amici a smettere di fumare",
        text: "Aiuta i tuoi amici a smettere di fumare"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, [
          _createVNode(_component_localized_text, {
            localizedKey: "Il tuo link",
            text: "Il tuo link"
          })
        ]),
        _createElementVNode("input", {
          type: "text",
          class: "form-control",
          readonly: "",
          value: _ctx.refLink
        }, null, 8, _hoisted_6),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary mt-2",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Copia link",
            text: "Copia link"
          })
        ]),
        _hoisted_7,
        (_ctx.copiato)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Copiato!",
                text: "Copiato!"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("canvas", _hoisted_10, null, 512)
      ])
    ]),
    (_ctx.showContatti)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstLine, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "wrapSpacer",
                key: i
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", null, _toDisplayString(i + 1), 1)
                  ]),
                  item
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(item.username), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          _createVNode(_component_caricamento_contratto, {
            class: "my-4",
            user: _ctx.user,
            reload: _ctx.reload
          }, null, 8, ["user", "reload"]),
          _hoisted_16,
          (_ctx.leads.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, "I tuoi contatti che ancora non hanno prenotato il loro appuntamento"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leads, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "listItem noPointer",
                key: item.identifier
              }, _toDisplayString(_ctx.$filters.date(item.createdOn, "YYYY-MM-DD HH:mm")) + " - " + _toDisplayString(item.username), 1))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}